app.directive('compareInterestExtended', ['$http', 'bezoeker', '$window', '$timeout', function($http, bezoeker, $window, $timeout){
    return {
        restrict: 'EAC',
        scope: {
          productvorm: '@?',
          titel: '@?',
          introtekst: '@?',
          bank: '@?'
        },
        templateUrl: '/templates/compare-interest-extended.html',
        link: function($scope, $element) {

            $scope.bezoeker = bezoeker;
            $scope.productvorm = 'persoonlijke lening';
            $scope.looptijd = 72;

            $scope.bedrag = bezoeker.gewenstLeenbedrag;
            $scope.combinatieRentetarieven = false;

            $scope.maandlastOptions = [{label : '€ '+($scope.bedrag * 0.01).toFixed(2).replace('.',','), value: 0},{label : '€ '+($scope.bedrag * 0.015).toFixed(2).replace('.',','), value: 1},{label: '€ '+($scope.bedrag * 0.02).toFixed(2).replace('.',','), value: 2}];
            $scope.maandlast = $scope.maandlastOptions[0];

            $scope.$watch('bedrag', function(){
                $scope.maandlastOptions = [{label : '€ '+($scope.bedrag * 0.01).toFixed(2).replace('.',','), value: 0},{label : '€ '+($scope.bedrag * 0.015).toFixed(2).replace('.',','), value: 1},{label: '€ '+($scope.bedrag * 0.02).toFixed(2).replace('.',','), value: 2}];
                $scope.maandlast = $scope.maandlastOptions[$scope.maandlast.value];
            }, true);

            $scope.Math = $window.Math;

            $scope.beingCompared = [];
            $scope.toBeCompared = [];
            $scope.clickedCompare = false;

            $scope.getRentetarieven = function(){

                if($scope.bedrag < 5000) $scope.bedrag = 5000;

                $scope.bezoeker.gewenstLeenbedrag = $scope.bedrag;
                $scope.bezoeker.store();

                var numb = $scope.bedrag.toString().match(/\d/g);
                $scope.bedrag = numb.join("");

                if($scope.bedrag < 75001){
                    $http.post('/rentetarieven/getInterestAllBanks/', {'bedrag' : $scope.bedrag, 'product' : $scope.productvorm, 'looptijd' : $scope.looptijd, 'maandlast' : $scope.maandlast.value, 'bank': $scope.bank}).

                    success(function(data, status, headers, config) {                        
                        $scope.rentetarieven = data;

                        $scope.beingCompared = data;
                        $scope.addTooltip();

                    });
                }else{
                    // $scope.showHybrideKredietText();
                }

            };

            $scope.addTooltip = function(){
                setTimeout(function() {
                    $('.tooltip').tooltipster({
                        multiple: true,
                        contentAsHTML: true,
                        interactive: true,
                    });
                }, 1000);                
            };

            $scope.bankImages = getBankImages();

            $scope.bankImagesMobile = getBankImages($type = 'mobile');

            $scope.getBankImage = function(bank)
            {
                if(typeof $scope.bankImages[bank] !== 'undefined')
                    return $scope.bankImages[bank];
                else
                    return false;
            };

            $scope.getBankImageMobile = function(bank)
            {
                if(typeof $scope.bankImagesMobile[bank] !== 'undefined')
                    return $scope.bankImagesMobile[bank];
                else 
                    return false;
            }

            $scope.onSubmit = function($event)
            {
                $event.preventDefault();
                var looptijd = null;
                var maandlast = null;
                var maandtermijnIndex = null;

                if($scope.productvorm == 'persoonlijke lening')
                {
                  looptijd = $scope.looptijd;
                }else{
                  maandtermijnIndex = $scope.maandlast.value;
                }

                $http.post('/session/saveUser/', {'productvorm' : $scope.productvorm, 'leenbedrag' : $scope.bedrag, 'looptijd' : looptijd, 'maandtermijnIndex' : maandtermijnIndex}).success(function(data, status, headers, config) {
                    $window.location.href = '/offerte-aanvragen/';
                });
            };

            $scope.onSubmitCombinatie = function($event)
            {
                $event.preventDefault();
                var looptijd = null;
                var maandlast = null;
                var maandtermijnIndex = null;

                if($scope.productvorm == 'persoonlijke lening')
                {
                  looptijd = $scope.looptijd;
                }else{
                  maandtermijnIndex = $scope.maandlast.value;
                }

                $http.post('/session/saveUser/', {'productvorm' : $scope.productvorm, 'leenbedrag' : $scope.bedrag, 'looptijd' : looptijd, 'maandtermijnIndex' : maandtermijnIndex}).success(function(data, status, headers, config) {
                    $window.location.href = '/offerte-aanvragen/#?combinatie=true&productvorm='+$scope.productvorm;
                });
            };

            $scope.placeInQueue = function(renteObject)
            {
                var isInQueue = false;
                var indexOf = 0;

                for (var i = 0; i < $scope.toBeCompared.length; i++) {

                    if ($scope.toBeCompared[i].naam == renteObject.naam) {
                        isInQueue = true;
                        indexOf = i;
                    }
                }

                if (!isInQueue) {
                    $scope.toBeCompared.push(renteObject);
                    renteObject.showInCompare = true;
                } else {
                    $scope.toBeCompared.splice(indexOf, 1);
                    renteObject.showInCompare = false;
                    if($scope.toBeCompared.length < 2)
                    {
                        $scope.resetComparison();
                    }
                }
            }

            $scope.startComparison = function ($event)
            {
                $scope.beingCompared = JSON.parse(JSON.stringify($scope.toBeCompared));
                $scope.clickedCompare = true;

                laagsteNominaal = 10.0;

                for (var i = 0; i < $scope.beingCompared.length; i++) {
                    
                    rentePercentage = $scope.beingCompared[i].rente.slice(0, -1);
                    rentePercentage = rentePercentage.replace(',','.');
                    rentePercentage = parseFloat(rentePercentage);

                    if(rentePercentage < laagsteNominaal){
                        goedkoopsteBank = $scope.beingCompared[i];
                        laagsteNominaal = rentePercentage;
                    }
                }
                for (var i = 0; i < $scope.beingCompared.length; i++) {
                    $scope.beingCompared[i].verschilTotaal = $scope.beingCompared[i].totaalprijs - goedkoopsteBank.totaalprijs;
                    $scope.beingCompared[i].verschilTotaal = $scope.beingCompared[i].verschilTotaal.toFixed(2);
                    
                    $scope.beingCompared[i].verschilMaandlast = $scope.beingCompared[i].maandlast - goedkoopsteBank.maandlast;
                    $scope.beingCompared[i].verschilMaandlast = $scope.beingCompared[i].verschilMaandlast.toFixed(2);
                }

            };

            $scope.resetComparison = function ($event)
            {
                $scope.beingCompared = JSON.parse(JSON.stringify($scope.rentetarieven));
                $scope.clickedCompare = false;

                for (var i = 0; i < $scope.beingCompared.length; i++) {
                    $scope.beingCompared[i].verschilTotaal = 0;
                    $scope.beingCompared[i].verschilMaandlast = 0;
                }
            };

            $scope.getRentetarieven();
        }
    };
}]);